import BigNumber from 'bignumber.js'

import type { UserTradingAnalyticsDailyDto } from '@root/shared/api/TradeApi'

export type UserTradingAnalyticsDaily = ReadonlyArray<UserTradingAnalyticsDay>

export interface UserTradingAnalyticsDay {
  date: Date
  buyVolumeUsd: BigNumber
  sellVolumeUsd: BigNumber
  pnlUsd: BigNumber
  realizedPnlUsd: BigNumber
  buys: number
  sells: number
}

export const fromDto = (
  dto: UserTradingAnalyticsDailyDto,
): UserTradingAnalyticsDaily => {
  return dto.map((it) => ({
    date: new Date(it.date),
    buyVolumeUsd: BigNumber(it.buyVolume.usd),
    sellVolumeUsd: BigNumber(it.sellVolume.usd),
    pnlUsd: BigNumber(it.pnl.usd),
    realizedPnlUsd: BigNumber(it.realizedPnl.usd),
    buys: it.buys,
    sells: it.sells,
  }))
}
